import { Light } from '../../../babylon/light-manager/light-system/lights/Light.js';
import { LightType } from '../../../api.js';
import { log_instance } from '../utils/LogInstance.js';
export const LIGHT_DESCRIPTION = {
    type: Light,
    name: 'default-light-description',
    is_enabled: true,
    on_select: (light) => {
        if (!light.debug_geomentry)
            light.create_debug_geometry();
    },
    on_deselect: (light) => {
        if (light.debug_geomentry)
            light.remove_debug_geometry();
    },
    transform: {
        position: (light) => ({
            get: () => light.position,
            set: (val) => { light.position = val; }
        })
    },
    initiate_tabs: [
        {
            tag: 'Light',
            custom_name: (light) => light.type,
            setup: (tab, light) => {
                tab.watch(light, 'id', { is_readonly: true });
                tab.watch(light, 'type', { is_readonly: true });
                tab.custom.watch('number', {
                    name: 'parent',
                    get: () => light.parent,
                    is_nullable: true
                });
                // We need to use custom since type checking of TrackedVec3 statisfy both IColor and IVector3
                tab.custom.watch('color', {
                    name: 'color',
                    get: () => light.color,
                    set: (v) => { light.color = v; }
                });
                tab.watch(light, 'intensity');
                // Spot Light
                if (is_spot_light(light)) {
                    tab.watch(light, 'inner_angle_degrees');
                    tab.watch(light, 'outer_angle_degrees');
                }
                // Directed Shadow Point Light
                if (is_directed_shadow_light(light)) {
                    tab.watch(light, 'shadow_angle_degrees');
                }
                // Line Light
                if (is_line_light(light)) {
                    tab.watch(light, 'width');
                    tab.watch(light, 'angle_direction_degrees');
                    tab.watch(light, 'angle_range_degrees');
                    tab.watch(light, 'hard_side_cutoff');
                    if (light.clip_plane) {
                        const container = tab.container('clip plane');
                        container.watch(light.clip_plane, 'normal');
                        container.watch(light.clip_plane, 'position');
                    }
                }
                tab.button('Dispose', {
                    on_click: () => light.dispose()
                });
                tab.button('Log', {
                    on_click: () => log_instance(light)
                });
            },
            dependencies: (light) => {
                const dependencies = [];
                if (is_line_light(light)) {
                    dependencies.push(() => light.clip_plane);
                }
                return dependencies;
            }
        },
        {
            tag: 'Transform',
            setup: (tab, light) => {
                // Spot Light
                if (is_spot_light(light)) {
                    tab.watch(light, 'direction');
                }
                // Directional Light
                if (is_directional_light(light)) {
                    tab.watch(light, 'target');
                }
                // Directed Shadow Point Light
                if (is_directed_shadow_light(light)) {
                    tab.watch(light, 'direction');
                }
            }
        },
        {
            tag: 'Physical',
            setup: (tab, light) => {
                tab.setter(light, 'set_color_temperature', 4000);
                // Point Light or Spot Light
                if (is_point_light(light) || is_spot_light(light)) {
                    tab.setter(light, 'set_intensity_lumen', 0);
                    tab.setter(light, 'set_intensity_candela', 0);
                }
                // Directional Light
                if (is_directional_light(light)) {
                    tab.setter(light, 'set_intensity_lux', 0);
                }
                // Line Light
                if (is_line_light(light)) {
                    tab.setter(light, 'set_intensity_lumen', 0);
                    tab.setter(light, 'set_intensity_candela', 0);
                    tab.setter(light, 'set_intensity_lumen_per_meter', 0);
                }
            }
        },
        {
            tag: 'Shadow',
            setup: (tab, light) => {
                tab.custom.watch('checkbox', {
                    name: 'Has Shadows',
                    get: () => !!light.shadow
                });
                if (light.shadow) {
                    const shadow = light.shadow;
                    tab.watch(shadow, 'enable_shadows');
                    tab.watch(shadow, 'shadow_near');
                    tab.watch(shadow, 'shadow_far');
                    tab.watch(shadow, 'shadow_resolution');
                    tab.button('Log', {
                        on_click: () => log_instance(shadow)
                    });
                }
            }
        }
    ]
};
function is_point_light(light) {
    return light.type === LightType.POINT_LIGHT;
}
function is_directional_light(light) {
    return light.type === LightType.DIRECTIONAL_LIGHT;
}
function is_spot_light(light) {
    return light.type === LightType.SPOT_LIGHT;
}
function is_line_light(light) {
    return light.type === LightType.LINE_LIGHT;
}
function is_directed_shadow_light(light) {
    return light.type === LightType.DIRECTED_SHADOW_POINT_LIGHT;
}
//# sourceMappingURL=LightDescription.js.map